var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileBackButtonIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 24 0)",
    fill: "#242424"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 8.12508L11.1205 12.0051L15.0005 15.8851C15.3905 16.2751 15.3905 16.9051 15.0005 17.2951C14.6105 17.6851 13.9805 17.6851 13.5905 17.2951L9.00047 12.7051C8.61047 12.3151 8.61047 11.6851 9.00047 11.2951L13.5905 6.70508C13.7773 6.51783 14.031 6.4126 14.2955 6.4126C14.56 6.4126 14.8136 6.51783 15.0005 6.70508C15.3805 7.09508 15.3905 7.73508 15.0005 8.12508Z",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBackButtonIconDark);
export default __webpack_public_path__ + "static/media/mobile-back-button-icon-dark.4a72d68d.svg";
export { ForwardRef as ReactComponent };